import { useEffect, Suspense, useCallback } from "react";
import { useAutoSignin } from "react-oidc-context";
import axios from "axios";

import { useAppDispatch } from "redux/store/hooks";
import Layout from "hoc/Layout/Layout";
import Router from "./routes/Router";
import Loader from "components/Loader/CustomLoader";

import withErrorHandler from "./hoc/withErrorHandler/withErrorHandler";
import useUserRoles from "shared/hooks/useUserRoles";

import * as actions from "redux/store/actions";

const App = () => {
  const { isLoading, isAuthenticated, error } = useAutoSignin();

  // Placing user roles in redux so class components can access them - eventually remove class components and use hooks
  const { userRoles } = useUserRoles();
  const dispatch = useAppDispatch();
  const saveUserRoles = useCallback(
    (roles: string[]) => {
      dispatch(actions.saveUserRoles(roles?.join(",")));
    },
    [dispatch]
  );

  useEffect(() => {
    if (userRoles) {
      saveUserRoles(userRoles);
    }
  }, [userRoles, saveUserRoles]);
  // Placing user roles in redux so class components can access them - eventually remove class components and use hooks

  if (isLoading) {
    return <div>Signing you in/out...</div>;
  }

  if (!isAuthenticated) {
    return <div>Unable to log in</div>;
  }

  if (error) {
    return <div>An authentication error occured</div>;
  }

  return (
    <Layout>
      <Suspense
        fallback={
          <div className="app-container-loader">
            <Loader />
          </div>
        }
      >
        <Router />
      </Suspense>
    </Layout>
  );
};

export default withErrorHandler(App, axios);
